import React from 'react';
import styled from 'styled-components';

import { Card } from 'antd';

import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Icon from 'components/ui/Icon';

const StyledCard = styled(Card)`
  ${(props) => props.cardOpen && 'max-height: 500px;'} border-radius: 16px;
`;
export const StyledIcon = styled(Icon)`
  font-size: 16px;
`;

export const StyledTitleText = styled.div`
  font-size: 18px;
`;
export const StyledSubTitleText = styled.div`
  font-size: 12px;
`;

export const StyledContainer = styled(Row)`
  ${(props) => props.cardOpen && 'margin-bottom: 12px;'};
`;

export const StyledChildContainer = styled(Row)`
  overflow-y: scroll;
  max-height: 400px;
`;

const CollapsableCard = ({ cardOpen, setCardOpen, title, subtitle, children }) => {
  return (
    <StyledCard cardOpen={cardOpen}>
      <StyledContainer onClick={() => setCardOpen(!cardOpen)} cardOpen={cardOpen}>
        <Col span={23}>
          <StyledTitleText>{title}</StyledTitleText>
          <StyledSubTitleText>{subtitle}</StyledSubTitleText>
        </Col>
        <Col span={1}>
          <StyledIcon type={cardOpen ? 'right' : 'down'} />
        </Col>
      </StyledContainer>
      {cardOpen && <StyledChildContainer>{children}</StyledChildContainer>}
    </StyledCard>
  );
};

export default CollapsableCard;
